<template>
    <div
        :class="`formulate-input-element formulate-input-element--${context.type}`"
        :data-type="context.type"
    >
        <vue-editor v-model="context.model" :editor-toolbar="customToolbar"
                    class="editor"></vue-editor>
    </div>
</template>

<script>
export default {
    props: {
        context: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            selectedIndex: 0,
            customToolbar: [
                [{header: [false, 1, 2, 3, 4, 5, 6]}],
                ['bold', 'italic', 'underline', 'strike'], // toggled buttons
                [
                    {align: ''},
                    {align: 'center'},
                    {align: 'right'},
                    {align: 'justify'},
                ],
                ['blockquote', 'code-block'],
                [{list: 'ordered'}, {list: 'bullet'}, {list: 'check'}],
                [{indent: '-1'}, {indent: '+1'}],
                [{color: []}, {background: []}],
                ['clean'],
            ],
        };
    },
};
</script>
